import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import AgeGate from './components/AgeGate/AgeGate';
import Home from './pages/Home/Home';
import Menu from './pages/Menu/Menu';
import About from './pages/About/About';
import TVMode from './pages/TVMode/TVMode';
import Privacy from './pages/Privacy/Privacy';
import './styles/variables.css';
import './App.css';

const AGE_GATE_STORAGE_KEY = 'goldenPour_ageVerified';

function App() {
  const [ageVerified, setAgeVerified] = useState(false);

  useEffect(() => {
    // Check localStorage on mount
    const verified = localStorage.getItem(AGE_GATE_STORAGE_KEY);
    if (verified === 'true') {
      setAgeVerified(true);
    }
  }, []);

  const handleAgeVerified = () => {
    setAgeVerified(true);
  };

  return (
    <Router>
      <div className="App">
        {!ageVerified && <AgeGate onVerified={handleAgeVerified} />}
        {ageVerified && (
          <>
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/about" element={<About />} />
                <Route path="/tv" element={<TVMode />} />
                <Route path="/privacy" element={<Privacy />} />
              </Routes>
            </main>
            <Footer />
          </>
        )}
      </div>
    </Router>
  );
}

export default App;